import { z } from "zod"

export const CustomerSchema = z.object({
  id: z.number(),
  email: z.string(),
  created_at: z.string(),
  updated_at: z.string(),
  events_count: z.number(),
  name: z.string().nullable(),
  custom_fields: z.record(z.string(), z.any()).nullable(),
  customer_devices_count: z.number(),
  source: z.enum(["event", "import"]),
  wants_campaigns: z.boolean(),
  wants_newsletters: z.boolean(),
})

export type Customer = z.infer<typeof CustomerSchema>
